import { Input, Button } from '@nazka/nazka.mapframe.components';
import theme from '@style/theme.json';

import './search.css';

function Search(props) {
  const {
    value, options, selectedValue, onSelect, color = theme?.color?.primary?.main,
    resultsTitle,
    ...inputProps
  } = props;

  return (
    <div
      className="search"
      style={{ '--search-color': color }}
    >
      <Input
        className="search__input"
        value={value}
        {...inputProps}
      />
      <div className="search__options">
        <h4>
          {resultsTitle}
        </h4>
        {!options.length && (
          <h5 className="search__options__placeholder">
            {props?.placeholder}
          </h5>
        )}
        {!!options.length && (
          <ul className="search__options__list">
            {options.map((option) => {
              const isSelected = selectedValue?.value === option?.value;
              return (
                <li
                  className="search__options__list__option"
                  onClick={() => onSelect(option)}
                  key={`${option?.label}-${option?.sublabel}`}
                >
                  <Button
                    layout="ghost"
                    className={`search__options__list__option__button${isSelected ? ' search__options__list__option__button--selected' : ''}`}
                  >
                    {option?.label}
                    {option?.sublabel && (
                      <span className="search__options__list__option__button__sublabel">
                        {`${option?.sublabel}`}
                      </span>
                    )}
                  </Button>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </div>
  )
}

export default Search;